/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    if (!this.container) {
      return;
    }

    this.form = this.container.querySelector('form.searchform');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');
    this.intentTip = this.container.querySelector('#Search-Intent-Tip');
    this.intentEnabled = this.container.dataset.searchIntentEnabled === 'true';
    this.intentKeyword = (this.container.dataset.searchIntentKeyword || '').trim().toLowerCase();

    this.onQuickSearchClick = this.onQuickSearchClick.bind(this);
    this.setupEventListeners();
  }

  setupEventListeners() {
    if (this.form) {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    }

    if (this.input) {
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }

    // Document delegation: survives header re-renders and works before window.load.
    document.addEventListener('click', this.onQuickSearchClick);
  }

  onQuickSearchClick(event) {
    const trigger = event.target.closest('.thb-quick-search');
    if (!trigger || !this.container) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    document.body.classList.toggle('open-cc');
    this.container.classList.toggle('active');

    if (this.container.classList.contains('active') && this.input) {
      setTimeout(() => {
        this.input.focus({
          preventScroll: true
        });
      }, 100);
      dispatchCustomEvent('search:open');
    }
  }

  getQuery() {
    return this.input ? this.input.value.trim() : '';
  }

  matchesIntentKeyword(searchTerm) {
    if (!this.intentEnabled || !this.intentTip || !this.intentKeyword) {
      return false;
    }

    return searchTerm.toLowerCase() === this.intentKeyword;
  }

  updateIntentTip(searchTerm) {
    if (!this.intentTip) {
      return;
    }

    if (this.matchesIntentKeyword(searchTerm)) {
      this.intentTip.hidden = false;
    } else {
      this.intentTip.hidden = true;
    }
  }

  onChange() {
    const searchTerm = this.getQuery();

    this.updateIntentTip(searchTerm);

    if (!searchTerm.length) {
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.classList.remove('active');
      }
      return;
    }

    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.classList.add('active');
      this.getSearchResults(searchTerm);
    }
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    this.updateIntentTip(searchTerm);

    if (!searchTerm.length || !this.predictiveSearchResults) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');

    if (submitButton) {
      submitButton.addEventListener('click', () => {
        _this.form.submit();
      });
    }
  }

  close() {
    this.container.classList.remove('active');
  }
}

function initPredictiveSearch() {
  if (window.__thbPredictiveSearchInit) {
    return;
  }
  if (typeof PredictiveSearch === 'undefined' || !document.getElementById('Search-Drawer')) {
    return;
  }
  window.__thbPredictiveSearchInit = true;
  new PredictiveSearch();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPredictiveSearch);
} else {
  initPredictiveSearch();
}
